import { CustomControlCode } from '@common/enums';
import { type RegisterParams, ServiceActivityRegistry } from '@common/workflow/serviceActivityRegistry';
import { echographyAdditionalQuestionRequestSections } from './echographyAdditionalQuestionRequest';
import { echographyAdditionalQuestionResponseSections } from './echographyAdditionalQuestionResponse';
import { echographyConsultRequestSections } from './echographyConsultRequest';
import { echographyConsultResponseSections } from './echographyConsultResponse';

const registryElements: RegisterParams[] = [
    {
        customControlCode: CustomControlCode.EchographyAdditionalQuestionRequest,
        sections: echographyAdditionalQuestionRequestSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.EchographyAdditionalQuestionResponse,
        sections: echographyAdditionalQuestionResponseSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.EchographyConsultRequest,
        sections: echographyConsultRequestSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.EchographyConsultResponse,
        sections: echographyConsultResponseSections,
        version: 1,
    },
];

ServiceActivityRegistry.instance.registerAll(registryElements);
